import React, { Component } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import bindModel from '../../common/bindModel.js';

export default class RecheckApplePage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            uid: null,
            orderId: "",
            searchedOrderId: "",
            transactions: null,
            loading: false
        }

        this.getTransactionInfo = this.getTransactionInfo.bind(this);
        this.recheckAppleTransaction = this.recheckAppleTransaction.bind(this);
        this.copyToClipboard = this.copyToClipboard.bind(this);
    }

    getTransactionInfo() {
        const { loading, orderId } = this.state;
        if (loading) return;
        if (!orderId || !orderId.trim()) {
            toast.warning("Vui lòng nhập Order ID");
            return;
        }

        this.setState({ loading: true });
        let json = {
            orderId: orderId.trim()
        }
        axios.post(global.config.apiDomain + '/rest/apple/transactioninfo', json)
            .then(res => {
                const transactions = Array.isArray(res.data) ? res.data : [];
                if (transactions.length === 0) {
                    toast.warning("Không tìm thấy transaction nào cho Order ID này");
                }
                this.setState({
                    transactions: transactions,
                    searchedOrderId: orderId.trim(),
                    loading: false
                })
            })
            .catch(() => {
                toast.error("Có lỗi xảy ra khi kiểm tra giao dịch");
                this.setState({ loading: false });
            });
    }

    recheckAppleTransaction() {
        const { loading } = this.state;
        if (loading) return;

        this.setState({ loading: true });
        let json = {
            orderId: this.state.orderId,
            uid: this.state.uid
        }
        axios.post(global.config.apiDomain + '/rest/apple/recheck', json)
            .then(res => {
                if (res.data.status == "OK") {
                    this.getTransactionInfo();
                    toast.success(res.data.message);
                } else {
                    toast.warning(res.data.message);
                }
                this.setState({ loading: false });
            })
            .catch(() => {
                toast.error("Có lỗi xảy ra khi xử lí giao dịch");
                this.setState({ loading: false });
            });
    }

    copyToClipboard(value, label) {
        if (!value) return;
        navigator.clipboard.writeText(value)
            .then(() => toast.success("Đã copy " + label))
            .catch(() => toast.error("Không copy được"));
    }

    renderStatusBadge(status) {
        if (status === "PROCESSED") {
            return <span className="badge badge-success px-2 py-1">Đã xử lí</span>;
        }
        if (status === "NO") {
            return <span className="badge badge-danger px-2 py-1">Chưa có trên hệ thống</span>;
        }
        return <span className="badge badge-warning px-2 py-1">Chưa xử lí{status ? ` (${status})` : ""}</span>;
    }

    renderInfoRow(label, value, copyable) {
        return (
            <tr>
                <td className="text-muted pl-3" style={{ width: "40%", whiteSpace: "nowrap" }}>{label}</td>
                <td className="font-weight-bold" style={{ wordBreak: "break-all" }}>
                    {value !== null && value !== undefined && value !== "" ? value : <span className="text-muted font-weight-normal">—</span>}
                    {copyable && value &&
                        <button
                            type="button"
                            className="btn btn-sm btn-link p-0 ml-2 align-baseline"
                            title={"Copy " + label}
                            onClick={() => this.copyToClipboard(value, label)}
                        >
                            <i className="fa fa-copy"></i>
                        </button>
                    }
                </td>
            </tr>
        );
    }

    renderTransactionCard(transaction, index) {
        return (
            <div key={transaction.transactionId || index} className="col-12 col-md-6 col-xl-4 mb-4 d-flex">
                <div className="card shadow-sm w-100">
                    <div className="card-header d-flex justify-content-between align-items-center bg-white">
                        <span className="font-weight-bold">#{index + 1} · {transaction.transactionId}</span>
                        {this.renderStatusBadge(transaction.status)}
                    </div>
                    <div className="card-body p-0">
                        <table className="table table-sm table-borderless mb-0 mt-2">
                            <tbody>
                                {this.renderInfoRow("Transaction ID", transaction.transactionId, true)}
                                {this.renderInfoRow("Original Transaction ID", transaction.originalTransactionId, true)}
                                {this.renderInfoRow("User ID", transaction.userId, true)}
                                {this.renderInfoRow("Device ID", transaction.deviceId, true)}
                                {this.renderInfoRow("UID", transaction.uid > 0 ? transaction.uid : null, true)}
                                {this.renderInfoRow("Product ID", transaction.productId)}
                                {this.renderInfoRow("Price", transaction.price != null ? transaction.price.toLocaleString() : null)}
                                {this.renderInfoRow("Currency", transaction.currency)}
                                {this.renderInfoRow("Country", transaction.storefront)}
                                {this.renderInfoRow("Environment", transaction.environment)}
                                {this.renderInfoRow("Signed date", transaction.signedDate ? new Date(transaction.signedDate).toLocaleString() : null)}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        const model = bindModel(this);
        const { loading, transactions, searchedOrderId } = this.state;

        return (
            <div id="content" className="container py-4">
                <h2 className="text-center mb-4">Kiểm tra giao dịch Apple</h2>

                <div className="row justify-content-center mb-4">
                    <div className="col-12 col-md-8 col-lg-6">
                        <div className="card shadow-sm">
                            <div className="card-body">
                                <div className="form-group">
                                    <label className="font-weight-bold">Order ID</label>
                                    <div className="input-group">
                                        <input
                                            {...model('orderId')}
                                            type="text"
                                            className="form-control"
                                            placeholder="Nhập Order ID (vd: MKX7W2FBD7)"
                                            onKeyDown={e => e.key === 'Enter' && this.getTransactionInfo()}
                                        />
                                        <div className="input-group-append">
                                            <button
                                                style={{ width: "110px" }}
                                                className="btn btn-primary"
                                                type="button"
                                                disabled={loading}
                                                onClick={this.getTransactionInfo}
                                            >
                                                {loading && <span className="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>}
                                                Kiểm tra
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div className="form-group mb-0">
                                    <label className="font-weight-bold">ID user (để xử lí lại)</label>
                                    <div className="input-group">
                                        <input
                                            {...model('uid')}
                                            type="text"
                                            className="form-control"
                                            placeholder="Nhập ID user cần cộng lại"
                                        />
                                        <div className="input-group-append">
                                            <button
                                                style={{ width: "110px" }}
                                                className="btn btn-success"
                                                type="button"
                                                disabled={loading}
                                                onClick={this.recheckAppleTransaction}
                                            >
                                                {loading && <span className="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>}
                                                Xử lí
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {transactions && transactions.length > 0 &&
                    <>
                        <h5 className="mb-3">
                            Order <span className="text-primary">{searchedOrderId}</span>
                            {" — "}
                            <span className="badge badge-info align-middle">{transactions.length} transaction</span>
                        </h5>
                        <div className="row">
                            {transactions.map((transaction, index) => this.renderTransactionCard(transaction, index))}
                        </div>
                    </>
                }

                {transactions && transactions.length === 0 &&
                    <div className="row justify-content-center">
                        <div className="col-12 col-md-8 col-lg-6">
                            <div className="alert alert-warning text-center mb-0">
                                Không tìm thấy transaction nào cho Order ID <strong>{searchedOrderId}</strong>
                            </div>
                        </div>
                    </div>
                }
            </div>
        )
    }
}
